import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Question } from 'src/app/core/models/questionnaire.model';
import { QuestionAnswer } from '../question/question.component';

@Component({
  selector: 'app-question-toggle',
  templateUrl: './question-toggle.component.html',
  styleUrls: ['./question-toggle.component.scss'],
})
export class QuestionToggleComponent implements OnInit {
  @Input('question') question!: Question;
  @Output('changeAnswer') changeAnswer: EventEmitter<QuestionAnswer> =
    new EventEmitter();

  ngOnInit(): void {
    this.validate();

    this.changeAnswer.next({
      answer: this.question.answer!,
      question: this.question,
    });
  }

  change() {
    this.validate();
    this.changeAnswer.next({
      answer: this.question.answer!,
      question: this.question,
    });
  }

  private validate() {
    if (this.question.elective) {
      this.question.isValid =
        this.question.answer!.value !== undefined &&
        this.question.answer!.value !== null;
    } else {
      this.question.isValid = !!this.question.answer!.value;
    }
  }
}

